export const ADDRESS_SEARCH_DEBOUNCE_MS = 500
export const MIN_ADDRESS_SEARCH_LENGTH = 3
export const DEFAULT_MAP_ZOOM = 17
export const INITIAL_MAP_ZOOM = 12
export const EMPTY_MAP_ZOOM = 6
export const MAP_ZOOM_ON_USER_LOCATION = 14
export const ADDRESS_QUERY_STALE_TIME_MS = 1000 * 60 * 60
